import type { Permission } from "@template/shared";
import type { ReactNode } from "react";
import { useHasPermission } from "./use-has-permission";

interface CanProps {
  /** Permission required to render `children`. */
  permission: Permission;
  /** Rendered when the permission is absent. Defaults to `null` (hidden). */
  fallback?: ReactNode;
  children: ReactNode;
}

/**
 * Declarative permission gate for JSX:
 *
 *   <Can permission="users.list">
 *     <Link to="/dashboard/admin/users">Users</Link>
 *   </Can>
 *
 * Non-admins never see the link. API calls are still authorised
 * independently — <Can> is a UI-rendering convenience, not a security
 * boundary.
 */
export function Can({ permission, fallback = null, children }: CanProps) {
  return useHasPermission(permission) ? <>{children}</> : <>{fallback}</>;
}
